<template>
  <el-dialog :title="$t('parkingAreaManage.addTitle')" :visible.sync="visible" width="800px" @close="closeDialog">
    <el-form ref="form" :model="addParkingAreaInfo" label-width="150px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('parkingAreaManage.parkingNum')" prop="num"
            :rules="[{ required: true, message: $t('parkingAreaManage.numRequired'), trigger: 'blur' }]">
            <el-input v-model.trim="addParkingAreaInfo.num" :placeholder="$t('parkingAreaManage.inputParkingNum')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('parkingAreaManage.parkingType')" prop="typeCd"
            :rules="[{ required: true, message: $t('parkingAreaManage.typeRequired'), trigger: 'change' }]">
            <el-select v-model="addParkingAreaInfo.typeCd" :placeholder="$t('parkingAreaManage.selectParkingType')"
              style="width: 100%">
              <el-option v-for="item in parkingTypes" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 公共车位数：0 表示不开放月租办理；正整数表示公共车位数量 -->
      <el-form-item :label="$t('parkingAreaManage.publicSpaceCount')" prop="publicSpaceCount"
        :rules="[{ required: true, message: $t('parkingAreaManage.publicSpaceCountPlaceholder'), trigger: 'blur' }]">
        <el-input v-model="addParkingAreaInfo.publicSpaceCount" type="number" min="0"
          :placeholder="$t('parkingAreaManage.publicSpaceCountPlaceholder')" />
        <div class="el-form-item__tip" style="color: #909399; font-size: 12px; line-height: 1.5;">
          {{ $t('parkingAreaManage.publicSpaceCountTip') }}
        </div>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <!-- 内部车是否占用公共车位名额：影响月租名额计算 -->
          <el-form-item :label="$t('parkingAreaManage.innerCarUsePublic')" prop="innerCarUsePublic"
            :rules="[{ required: true, message: $t('parkingAreaManage.innerCarUsePublicPlaceholder'), trigger: 'change' }]">
            <el-select v-model="addParkingAreaInfo.innerCarUsePublic"
              :placeholder="$t('parkingAreaManage.innerCarUsePublicPlaceholder')" style="width: 100%">
              <el-option :label="$t('common.yes')" value="Y" />
              <el-option :label="$t('common.no')" value="N" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 同车位多车入场控制策略 -->
          <el-form-item :label="$t('parkingAreaManage.multiCarInType')" prop="multiCarInType"
            :rules="[{ required: true, message: $t('parkingAreaManage.multiCarInTypePlaceholder'), trigger: 'change' }]">
            <el-select v-model="addParkingAreaInfo.multiCarInType"
              :placeholder="$t('parkingAreaManage.multiCarInTypePlaceholder')" style="width: 100%">
              <el-option :label="$t('parkingAreaManage.multiCarInTypeForbid')" value="0" />
              <el-option :label="$t('parkingAreaManage.multiCarInTypeAllow')" value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 同车位多车入场被拦截时的提示语，空则使用默认提示 -->
      <el-form-item :label="$t('parkingAreaManage.multiCarInMsg')" prop="multiCarInMsg">
        <el-input v-model="addParkingAreaInfo.multiCarInMsg" type="textarea" :rows="2"
          :placeholder="$t('parkingAreaManage.multiCarInMsgPlaceholder')" />
      </el-form-item>

      <div v-for="(item, index) in addParkingAreaInfo.attrs" :key="index">
        <el-form-item v-if="item.specType === '2233'" :label="item.specName" :prop="`attrs[${index}].value`"
          :rules="item.required === 'Y' ? [{ required: true, message: $t('common.required'), trigger: 'blur' }] : []">
          <el-input v-model="item.value" :placeholder="item.specHoldplace" />
        </el-form-item>

        <el-form-item v-if="item.specType === '3344'" :label="item.specName" :prop="`attrs[${index}].value`"
          :rules="item.required === 'Y' ? [{ required: true, message: $t('common.required'), trigger: 'change' }] : []">
          <el-select v-model="item.value" :placeholder="item.specHoldplace" style="width: 100%">
            <el-option v-for="value in item.values" :key="value.value" :label="value.valueName" :value="value.value" />
          </el-select>
        </el-form-item>
      </div>

      <el-form-item :label="$t('parkingAreaManage.remark')">
        <el-input v-model="addParkingAreaInfo.remark" type="textarea" :rows="3"
          :placeholder="$t('parkingAreaManage.remarkPlaceholder')" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveParkingAreaInfo" :loading="saving">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveParkingArea } from '@/api/car/parkingAreaManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getAttrSpecList } from '@/api/dev/attrSpecApi'
import { getAttrValueList } from '@/api/dev/attrValueApi'

export default {
  name: 'AddParkingArea',
  data() {
    return {
      visible: false,
      saving: false,
      addParkingAreaInfo: {
        num: '',
        typeCd: '',
        publicSpaceCount: 0,
        innerCarUsePublic: 'N',
        multiCarInType: '0',
        multiCarInMsg: '',
        remark: '',
        attrs: []
      },
      parkingTypes: [
        { value: '1001', label: this.$t('parkingAreaManage.aboveGround') },
        { value: '2001', label: this.$t('parkingAreaManage.underground') }
      ]
    }
  },
  methods: {
    open() {
      this.visible = true
      this.resetForm()
      this._loadParkingAreaAttrSpec()
    },

    closeDialog() {
      this.$refs.form.resetFields()
    },

    resetForm() {
      this.addParkingAreaInfo = {
        num: '',
        typeCd: '',
        publicSpaceCount: 0,
        innerCarUsePublic: 'N',
        multiCarInType: '0',
        multiCarInMsg: '',
        remark: '',
        attrs: []
      }
    },

    async saveParkingAreaInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          this.saving = true
          const params = {
            ...this.addParkingAreaInfo,
            communityId: getCommunityId()
          }
          // 确保公共车位数为非负整数
          params.publicSpaceCount = parseInt(params.publicSpaceCount, 10)
          if (isNaN(params.publicSpaceCount) || params.publicSpaceCount < 0) {
            params.publicSpaceCount = 0
          }

          await saveParkingArea(params)
          this.$message.success(this.$t('common.operationSuccess'))
          this.visible = false
          this.$emit('success')
        } catch (error) {
          console.error('添加停车场失败:', error)
          this.$message.error(this.$t('parkingAreaManage.addFailed'))
        } finally {
          this.saving = false
        }
      })
    },

    async _loadParkingAreaAttrSpec() {
      try {
        const { data } = await getAttrSpecList({
          page: 1,
          row: 100,
          tableName: 'parking_area_attr'
        })
        const attrs = []
        data.forEach(item => {
          if (item.specShow === 'Y') {
            item.value = ''
            item.values = []
            this._loadAttrValue(item.specCd, item.values)
            attrs.push(item)
          }
        })
        this.addParkingAreaInfo.attrs = attrs
      } catch (error) {
        console.error('加载停车场属性失败:', error)
      }
    },

    async _loadAttrValue(specCd, values) {
      try {
        const { data } = await getAttrValueList({ specCd, page: 1, row: 100 })
        data.forEach(item => {
          if (item.valueShow === 'Y') {
            values.push(item)
          }
        })
      } catch (error) {
        console.error('加载属性值失败:', error)
      }
    }
  }
}
</script>
